/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-card[_ngcontent-%COMP%]{margin:75px 15px 0;padding:5px 0}.breadcrumbs[_ngcontent-%COMP%]{padding:5px;margin:15px 0;list-style:none}.breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline-block}.breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:first-child:before{padding:0 5px;color:#ccc;content:\"/\"}.breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}"];
export { styles as styles };
